import { useEffect } from "react";
import axios from "axios";
import { API } from "./api";

// Instant visitor notification for key pages. Fires once per page per browser session.
export const useTrack = (page) => {
  useEffect(() => {
    if (!API || !page) return;
    const key = `gd-track-${page}`;
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, "1"); } catch { /* private mode */ }
    const u = new URL(window.location.href);
    axios.post(`${API}/track`, {
      page, path: u.pathname + u.search, referrer: document.referrer || "", title: document.title,
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone || "", lang: navigator.language || "",
      screen: `${window.screen.width}x${window.screen.height}`,
      utm: Object.fromEntries([...u.searchParams].filter(([k]) => k.startsWith("utm_"))),
    }).catch(() => {});
  }, [page]);
};
